import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Loading from "../SpinnerAndError/Loading";
import { useLocation } from "react-router-dom";
import { Row, Col } from "antd";

import moment from "moment";
import { OverlayTrigger } from "react-bootstrap";
import { Table, Space, Card } from "antd";
import { FallOutlined, RiseOutlined } from "@ant-design/icons";
import SmallSpinner from "../SpinnerAndError/SmallSpinner";

const ReadonlyViewPage = () => {
  const [logoUrl, setLogoUrl] = useState("");
  const [recievedColumns, setRecievedColumns] = useState([]);
  const [updatedColumns, setUpdatedColumns] = useState([]);
  const [data, setData] = useState(null);
  const [
    arrayOfKeywordsWithAllInformation,
    setArrayOfKeywordsWithAllInformation,
  ] = useState([]);
  const [featuredSnippet, setFeaturedSnippet] = useState(false);
  const [newDataSourceForTheTable, setNewDataSourceForTheTable] = useState([]);
  //FOR THE SUMMARY CARDS
  const [averagePositionForKeywords, setAveragePositionForKeywords] =
    useState(0);
  const [
    yesterdaysAveragePositionForKeywords,
    setYesterdaysAveragePositionForKeywords,
  ] = useState(0);

  const [
    numberOfKeywordsThatHasImprovedSinceYesterday,
    setNumberOfKeywordsThatHasImprovedSinceYesterday,
  ] = useState(0);
  const [numberOfKeywordsInTop3, setNumberOfKeywordsInTop3] = useState(0);
  const [numberOfKeywordsInTop10, setNumberOfKeywordsInTop10] = useState(0);
  const [numberOfKeywordsInTop30, setNumberOfKeywordsInTop30] = useState(0);
  const [numberOfKeywordsInTop100, setNumberOfKeywordsInTop100] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop3,
    setYesterdaysNumberOfKeywordsInTop3,
  ] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop10,
    setYesterdaysNumberOfKeywordsInTop10,
  ] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop30,
    setYesterdaysNumberOfKeywordsInTop30,
  ] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop100,
    setYesterdaysNumberOfKeywordsInTop100,
  ] = useState(0);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const websiteId = searchParams.get("websiteId");
  const token = searchParams.get("token");

  useEffect(() => {
    const selectedColumns = JSON.parse(
      decodeURIComponent(searchParams.get("selectedColumns")) || "[]"
    );

    const fetchData = async () => {
      try {
        const url = `${process.env.REACT_APP_VIEW_UNIQUE_LINK}?websiteId=${websiteId}&token=${token}`;

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(data.message || "Something went wrong.");
        } else if (response.ok) {
          const data = await response.json();
          console.log(data);
          const receivedColumnsFromBackend = data.selectedColumns;
          setLogoUrl(data?.logoUrl);
          setRecievedColumns(receivedColumnsFromBackend);

          const whatKeywordsToIncludeInTable =
            data.whatKeywordsToIncludeInUniqueLink;

          const updatedColumnsFromBackend = columns.filter((col) => {
            const dataIndex = receivedColumnsFromBackend.find((rc) =>
              rc.toLowerCase().includes(col.dataIndex.toLowerCase())
            );
            if (dataIndex) {
              col.dataIndex = dataIndex;
              /* console.log(`Column ${col.title}: dataIndex=${col.dataIndex}`); */
              return true;
            } else {
              /* console.log(`Column ${col.title} not found in received columns`); */
              return false;
            }
          });

          setUpdatedColumns(updatedColumnsFromBackend);

          const arrayOfKeywordsFromBackend = data?.keywords;

          setArrayOfKeywordsWithAllInformation(arrayOfKeywordsFromBackend);

          //think I can delete this one.
          const numberOfKeywordsToday = arrayOfKeywordsFromBackend.length;

          let keywordPositionSumArray = [];
          let yesterdaysKeywordPositionSumArray = [];
          let numberOfImprovedKeywordsArray = [];
          let numberOfKeywordsBetween1And3Array = [];
          let numberOfKeywordsInTop10Array = [];
          let numberOfKeywordsInTop30Array = [];
          let numberOfKeywordsInTop100Array = [];
          let yesterdaysNumberOfKeywordsBetween1And3Array = [];
          let yesterdaysNumberOfKeywordsInTop10Array = [];
          let yesterdaysNumberOfKeywordsInTop30Array = [];
          let yesterdaysNumberOfKeywordsInTop100Array = [];

          if (Object.keys(arrayOfKeywordsFromBackend).length > 0) {
            const filteredKeywords = arrayOfKeywordsFromBackend.filter(
              (e, index) => {
                const currentRankingPosition =
                  e.currentRankingPosition || Infinity;
                if (whatKeywordsToIncludeInTable === 0) {
                  return true; // include all keywords
                } else if (whatKeywordsToIncludeInTable === 3) {
                  return currentRankingPosition <= 3; // include keywords in top 3
                } else if (whatKeywordsToIncludeInTable === 10) {
                  return currentRankingPosition <= 10; // include keywords in top 10
                } else if (whatKeywordsToIncludeInTable === 30) {
                  return currentRankingPosition <= 30; // include keywords in top 30
                } else {
                  return false; // unknown option
                }
              }
            );

            filteredKeywords.forEach((e, index) => {
              const lowestNumber = e.historicRankingsForThisKeyword.reduce(
                (a, b) => (a.rankingPosition < b.rankingPosition ? a : b),
                { rankingPosition: Infinity }
              );

              const firstTrackedPosition =
                e.historicRankingsForThisKeyword[0]?.rankingPosition; // THIS IS THE POSITION THAT WAS THE FIRST ONE WHEN KEYWORD WAS FIRST ADDED.
              const latest =
                e.historicRankingsForThisKeyword.slice(-1)[0]
                  ?.rankingPosition || Infinity;
              // THIS IS GIVING BACK THE LAST ONE IN THE ARRAY
              /* const previousToLatest =
                e.historicRankingsForThisKeyword.slice(-2)[0]?.rankingPosition ||
                Infinity; */
              const historicRankings = e.historicRankingsForThisKeyword;
              const previousToLatest =
                historicRankings.length <= 1
                  ? "-"
                  : historicRankings.slice(-2)[0]?.rankingPosition || Infinity;
              // THIS IS GIVING BACK THE SECOND LATEST POSITION IN THE ARRAY
              const change = latest - previousToLatest;

              if (change < 0) {
                //IF THE KEYWORD HAS IMPROVED IN RANKING (MEANING THAT IT IS MINUS) , THEN I PUSH "1" TO THE ARRAY
                numberOfImprovedKeywordsArray.push(1);
              }
              //THIS IS FOR CALCULATING THE AVERAGE POSITION
              if (Number.isInteger(e.currentRankingPosition))
                keywordPositionSumArray.push(e.currentRankingPosition);
              //THIS IS FOR CALCULATING YESTERDAYS AVERAGE POSITION
              if (Number.isInteger(previousToLatest))
                yesterdaysKeywordPositionSumArray.push(previousToLatest);

              //BELOW I AM CALCULATING THE NUMBER OF KEYWORDS IN TOP3/10/30/100
              if (e.currentRankingPosition <= 3) {
                numberOfKeywordsBetween1And3Array.push(1);
              }
              if (e.currentRankingPosition <= 10) {
                numberOfKeywordsInTop10Array.push(1);
              }
              if (e.currentRankingPosition <= 30) {
                numberOfKeywordsInTop30Array.push(1);
              }
              if (e.currentRankingPosition <= 100) {
                numberOfKeywordsInTop100Array.push(1);
              }
              //BELOW I AM CALCULATING YESTERDAYS NUMBER OF KEYWORDS IN TOP3/10/30/100
              if (previousToLatest <= 3) {
                yesterdaysNumberOfKeywordsBetween1And3Array.push(1);
              }
              if (previousToLatest <= 10) {
                yesterdaysNumberOfKeywordsInTop10Array.push(1);
              }
              if (previousToLatest <= 30) {
                yesterdaysNumberOfKeywordsInTop30Array.push(1);
              }
              if (previousToLatest <= 100) {
                yesterdaysNumberOfKeywordsInTop100Array.push(1);
              }

              const best = lowestNumber?.rankingPosition || Infinity;
              const first = firstTrackedPosition || Infinity;
              const last_updated = e.lastUpdate || Infinity;
              const url_ranking = e.URLRanking || Infinity;

              const featuredSnippetDisplayedLink =
                e.allSerpInfoForKeyword?.answer_box?.link;
              const hasFeaturedSnippet = Boolean(featuredSnippetDisplayedLink);
              if (hasFeaturedSnippet) {
                setFeaturedSnippet(true);
              }

              const keywordNeedsToBeUpdated =
                e.keywordNeedsToBeUpdatedFirstTime;

              //These moment consts are used for calculating the time since last update , which is used in the table.
              const momentLastUpdated = moment(last_updated);
              const timeDifference = moment().diff(momentLastUpdated);
              const formattedLastUpdated =
                moment.duration(timeDifference).humanize() + " ago";

              if (keywordNeedsToBeUpdated) {
                const latestChange = setNewDataSourceForTheTable((data) => [
                  ...data,
                  {
                    key: index + 1,
                    keyword: e.keyword,
                    change: 0,
                    latest: Infinity,
                    yesterday: previousToLatest || 0,
                    best: Infinity,
                    first: Infinity,
                    last_updated: Infinity,
                    url_ranking: Infinity,
                    action: "delete",
                  },
                ]);
              } else {
                const latestChange = setNewDataSourceForTheTable((data) => [
                  ...data,
                  {
                    key: index + 1,
                    keyword: e.keyword,
                    change: change || 0,
                    latest: latest || 0,
                    yesterday: previousToLatest || 0,
                    best: best,
                    first: first,
                    featured_snippet: featuredSnippetDisplayedLink,
                    last_updated: formattedLastUpdated, //moment date from above. To calculate time since last update
                    url_ranking: url_ranking,
                    action: "delete",
                  },
                ]);
              }
            });
            //BELOW HERE I AM DOING ALL THE CALCULATIONS FOR THE SUMMARY CARDS BASED ON THE ARRAYS I AM PUSHING INTO ABOVE

            //CALCULATING TODAYS TOTAL SUM OF KEYWORDS (ADDING THEM TOGETHER)
            const sumOfAllCurrentPositions = keywordPositionSumArray.reduce(
              //I AM ADDING (PLUSSING) ALL POSITIONS TOGETHER.
              (partialSum, a) => partialSum + a,
              0
            );

            /*   const numberOfKeywords = newDataSourceForTheTable.length; */ //NUMBER OF KEYWORDS BEING TRACKED

            const averagePosition =
              sumOfAllCurrentPositions / numberOfKeywordsToday; //GETTING THE AVERAGE POSITION BY DIVIDING THE SUM BY THE NUMBER OF KEYWORDS

            const first4StrOfAveragePosition = String(averagePosition).slice(
              // I JUST NEED THE FIRST 4 STRINGS
              0,
              4
            ); // I ONLY WANT THE FIRST 4 NUMBERS (IN CASE IT IS A VERY LONG NUMBER)

            setAveragePositionForKeywords(first4StrOfAveragePosition);

            //CALCULATING YESTERDAYS TOTAL SUM OF KEYWORDS (ADDING THEM TOGETHER)
            const sumOfAllYesterdaysPositions =
              yesterdaysKeywordPositionSumArray.reduce(
                //I AM ADDING (PLUSSING) ALL POSITIONS TOGETHER.
                (partialSum, a) => partialSum + a,
                0
              );

            /* const numberOfKeywords2 = newDataSourceForTheTable.length; */ //THIS IS ACTUALLY NOT 100% CORRECT AS THIS IS TODAYS NUMBER OF TRACKED KWYWORDS.
            /* console.log("Number of Keywords yesterday: ", numberOfKeywords2); */
            const yesterdaysAveragePosition =
              sumOfAllYesterdaysPositions / numberOfKeywordsToday; //GETTING THE AVERAGE POSITION BY DIVIDING THE SUM BY THE NUMBER OF KEYWORDS

            const first4StrOfYesterdaysAveragePosition = String(
              // I JUST NEED THE FIRST 4 STRINGS
              yesterdaysAveragePosition
            ).slice(0, 4);
            setYesterdaysAveragePositionForKeywords(
              first4StrOfYesterdaysAveragePosition
            );

            //BELOW I AM CALCULATING THE NUMBER OF KEYWORDS THAT HAVE IMPROVED SINCE THE DAY BEFORE.
            const numberOfKeywordsThatImproved =
              numberOfImprovedKeywordsArray.length;

            setNumberOfKeywordsThatHasImprovedSinceYesterday(
              numberOfKeywordsThatImproved
            );
            //BELOW I AM CALCULATING THE LENGTH OF THE "KEYWORDS IN TOP 3/10/30/100" ARRAYS
            //AND SETTING THEM IN STATE.
            const numberOfKeywordsInTop3 =
              numberOfKeywordsBetween1And3Array.length;
            const numberOfKeywordsInTop10 = numberOfKeywordsInTop10Array.length;
            const numberOfKeywordsInTop30 = numberOfKeywordsInTop30Array.length;
            const numberOfKeywordsInTop100 =
              numberOfKeywordsInTop100Array.length;

            setNumberOfKeywordsInTop3(numberOfKeywordsInTop3);
            setNumberOfKeywordsInTop10(numberOfKeywordsInTop10);
            setNumberOfKeywordsInTop30(numberOfKeywordsInTop30);
            setNumberOfKeywordsInTop100(numberOfKeywordsInTop100);

            //BELOW I AM CALCULATING THE LENGTH OF "YESTERDAYS KEYWORDS IN TOP 3/10/30/100" ARRAYS
            //AND SETTING THEM IN STATE.

            const yesterdaysNumberOfKeywordsInTop3 =
              yesterdaysNumberOfKeywordsBetween1And3Array.length;
            const yesterdaysNumberOfKeywordsInTop10 =
              yesterdaysNumberOfKeywordsInTop10Array.length;
            const yesterdaysNumberOfKeywordsInTop30 =
              yesterdaysNumberOfKeywordsInTop30Array.length;
            const yesterdaysNumberOfKeywordsInTop100 =
              yesterdaysNumberOfKeywordsInTop100Array.length;

            setYesterdaysNumberOfKeywordsInTop3(
              yesterdaysNumberOfKeywordsInTop3
            );
            setYesterdaysNumberOfKeywordsInTop10(
              yesterdaysNumberOfKeywordsInTop10
            );
            setYesterdaysNumberOfKeywordsInTop30(
              yesterdaysNumberOfKeywordsInTop30
            );
            setYesterdaysNumberOfKeywordsInTop100(
              yesterdaysNumberOfKeywordsInTop100
            );
          }

          setData(data);
        }
      } catch (error) {
        console.error(error);
        setData(null);
      }
    };
    fetchData();
  }, [websiteId, token]);

  /* const columns = [
    {
      title: "Keyword",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Position",
      dataIndex: "position",
      key: "position",
    },
  ]; */

  // THESE ARE THE COLUMNS USED FOR THE OVERALL!! TABLE *****************************
  const columns = [
    {
      /* title: "Keyword", */
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Keyword</span>{" "}
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  Your keyword.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "keyword",
      key: "keyword",
      fixed: "left",
      width: 150,
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Change</span>{" "}
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  Difference between yesterdays position and today's.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "change",
      key: "change",
      width: 80,
      render: (_, record) =>
        record.change < 0 ? (
          <span>
            {_}
            <RiseOutlined style={{ color: "green" }} />
          </span>
        ) : record.change === 0 ? (
          _
        ) : (
          <span>
            {_}
            <FallOutlined style={{ color: "red" }} />
          </span>
          /* (record, (<FallOutlined />)) */
          /* (record, (<RiseOutlined />)) */
        ),
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Latest</span>{" "}
            <OverlayTrigger
              key="left"
              placement="bottom"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The latest ranking position.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },

      dataIndex: "latest",
      key: "latest",
      width: 80,
      render: (value) => (value === Infinity ? <SmallSpinner /> : value),
      sorter: (a, b) => a.latest - b.latest,
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Yesterday</span>{" "}
            <OverlayTrigger
              key="left"
              placement="bottom"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  Yesterdays ranking position.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },

      dataIndex: "yesterday",
      key: "yesterday",
      width: 80,
      render: (value) => (value === Infinity ? <SmallSpinner /> : value),
      sorter: (a, b) => a.yesterday - b.yesterday,
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Best</span>{" "}
            <OverlayTrigger
              key="left"
              placement="bottom"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The highest position since starting to track keyword.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },

      dataIndex: "best",
      key: "best",
      width: 80,
      render: (value) => (value === Infinity ? <SmallSpinner /> : value),
      sorter: (a, b) => a.best - b.best,
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>First</span>{" "}
            <OverlayTrigger
              key="left"
              placement="bottom"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The position when the keyword was added.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "first",
      key: "first",
      width: 80,

      sorter: (a, b) => a.first - b.first,
      render: (_, record) =>
        record.first === Infinity ? (
          <SmallSpinner />
        ) : record.first === "Not ranking in top 100" ? (
          _
        ) : record.first > record.latest ? (
          <span>
            {_}
            <RiseOutlined style={{ color: "green" }} />
          </span>
        ) : record.first === record.latest ? (
          _
        ) : (
          <span>
            {_}
            <FallOutlined style={{ color: "red" }} />
          </span>
        ),
    },
    ...(featuredSnippet
      ? [
          {
            title: () => {
              return (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span style={{ paddingRight: "2px" }}>
                    Featured snippet link
                  </span>{" "}
                  <OverlayTrigger
                    key="left"
                    placement="top"
                    overlay={
                      <tooltipBootstrap
                        id={`tooltip-${"left"}`}
                        style={{
                          background: "#E6F7FF",
                          maxWidth: "250px",
                          padding: "8px",
                          borderRadius: "4px",
                        }}
                      >
                        A featured snippet is a summary of an answer to a search
                        query that is displayed prominently at the top of the
                        search results page in what's called the "position zero"
                        or "rank zero" position.<br></br>
                        <br></br> In terms of SEO, getting your content featured
                        as a snippet can be highly valuable because it can
                        increase your website's visibility and click-through
                        rates.
                      </tooltipBootstrap>
                    }
                  >
                    <i
                      style={{ color: "#A5A5A5" }}
                      className="bi bi-info-circle"
                    ></i>
                  </OverlayTrigger>
                </div>
              );
            },
            dataIndex: "featured_snippet",
            key: "featured_snippet",
            width: 100,
            render: (value) => {
              const contentStyle = { fontSize: "11px" };
              return value === Infinity ? (
                <SmallSpinner />
              ) : (
                <span style={contentStyle}>{value}</span>
              );
            },
          },
        ]
      : []),

    {
      title: "Last updated",
      dataIndex: "last_updated",
      key: "last_updated",
      width: 100,
      render: (value) => (value === Infinity ? <SmallSpinner /> : value),
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>URL ranking</span>{" "}
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The URL that is ranking for the keyword.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "url_ranking",
      key: "url_ranking",
      width: 100,
      render: (value) => {
        const contentStyle = { fontSize: "11px" };
        return value === Infinity ? (
          <SmallSpinner />
        ) : (
          <span style={contentStyle}>{value}</span>
        );
      },
    },

    /* {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Top domains & Trend</span>{" "}
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  Shows the top domains as well as the historic ranking
                  positions shown in a graph.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },

      key: "trend",
      width: 70,
      render: (_, record) => (
        <div style={{ display: "flex" }}>
          <Space size="middle" style={{ paddingRight: "2px" }}>
            <span
              onClick={openUpTheTop100Modal}
              className="show-top-domains-for-the-keyword"
            >
              <OrderedListOutlined />
            </span>
          </Space>
          <Space size="middle" style={{ paddingRight: "2px" }}>
            <span
              onClick={openUpTheTrendModal}
              className="show-top-domains-for-the-keyword"
            >
              <AreaChartOutlined />
            </span>
          </Space>
        </div>
      ),
    }, */
    /* {
      title: "Update keyword",
      key: "update",
      width: 70,
      render: (_, record) => (
        <Space size="middle">
          <span
            onClick={updateKeywordFunction}
            className="show-top-domains-for-the-keyword"
          >
            <SyncOutlined />
          </span>
        </Space>
      ),
    }, */
    /* {
      title: "Delete",
      key: "action",
      width: 60,
      render: (_, record) => (
        <Space size="middle">
          <span
            onClick={openUpTheDeleteKeywordModal}
            className="remove-item-box-for-deleting-a-keyword"
          >
            <DeleteOutlined />
          </span>
        </Space>
      ),
    }, */
  ];

  if (!data) {
    return <Loading />;
  }

  return (
    <Row>
      <Col xs={{ span: 24 }} lg={{ span: 20, offset: 2 }}>
        <Card
          className="first-time-user-card"
          title={
            <div className="card-title-body">
              <span className="card-title">Keyword Overview</span>
              <p
                style={{
                  color: "green",
                  fontSize: "1.4em",
                  fontWeight: "700",
                  marginBottom: "0.5em",
                }}
              >
                {data.trackedUserDomain}
              </p>
              <span
                style={{
                  fontSize: "0.8em",
                  textDecoration: "underline",
                  color: "red",
                }}
              >
                Read-only table
              </span>
            </div>
          }
          extra={<></>}
          style={{
            width: "100%",
          }}
        >
          {Array.isArray(newDataSourceForTheTable) &&
          newDataSourceForTheTable.length ? (
            <Table
              scroll={{ x: 500 }}
              pagination={{ pageSize: 15 }}
              dataSource={newDataSourceForTheTable}
              columns={updatedColumns}
              size="small"
              width="100%"
            />
          ) : null}

          {/* Show the logoUrl at the bottom of the Card */}
          <div style={{ marginTop: "2em" }}>
            <img src={data.logoUrl} alt="Logo" style={{ height: "50px" }} />
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default ReadonlyViewPage;
